import { Subject } from 'rxjs';

export class LazySubject extends Subject<void> {
    private timeout?: ReturnType<typeof setTimeout>;
    private nextFire: number | null = null;

    /** Fires only once at most after wait ms */
    fire(wait: number) {
        const time = Date.now();
        const nextFire = time + wait;
        if (!this.nextFire || nextFire < this.nextFire) {
            clearTimeout(this.timeout);
            this.nextFire = nextFire;
            this.timeout = setTimeout(() => this.onTimeout(), wait);
        }
    }

    private onTimeout() {
        this.timeout = undefined;
        this.nextFire = null;
        this.next();
    }

    clear() {
        clearTimeout(this.timeout);
        this.timeout = undefined;
        this.nextFire = null;
    }
}
